import { configureStore } from '@reduxjs/toolkit';
import brandReducer from './slice/brandSlice';
import pngReducer from './pngSurvey/slice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import sahaytaCentreReducer from './sahaytaCentre/slice';


const surveyPersitConfig = {
	key: 'pngSurvey',
	storage: storage,
	whitelist: ['surveyActiveQuestions'],
};

const surveyPersitReducer = persistReducer(surveyPersitConfig, pngReducer);

const store = configureStore({
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
			},
		}),
	reducer: {
		brand: brandReducer,
		pngSurvey: surveyPersitReducer,
		sahaytaCentre: sahaytaCentreReducer,
	},
});

export const persistor = persistStore(store);
export default store;
